'use client';

import { base64ToObject } from '@bgzt/utils';
import { AppLogContext } from '.';
import { APP_LOG_CONTEXT_STORAGE_KEY } from './key';

/**
 * App에서 주입해주는 log context 정보를 가져온다
 *
 * @see {@link https://quicket.atlassian.net/wiki/spaces/BUN/pages/1346273571/Client+Log+Context+with+HTTP+Request}
 */
export const getAppLogContext = (): AppLogContext | undefined => {
  const stringifiedAppLogContext = globalThis.window?.sessionStorage?.getItem(APP_LOG_CONTEXT_STORAGE_KEY);

  if (!stringifiedAppLogContext) return;

  const appLogContext = base64ToObject(stringifiedAppLogContext);
  return appLogContext;
};
